
import GuidanceMixin from '~/mixins/guidance'

export default {
    mixins: [GuidanceMixin]
}
